import {
    IAgendamentosComunicadosRequest,
    IAgendamentosComunicadosResponse,
    IAgendarComunicadoEmMassaAudiencia,
    IAudiencia,
    IComunicadoEmMassa,
    ILogComunicado,
} from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetsAudienciaService() {
    return Service(
        Axios.get<Array<IAudiencia>>(`/automacao/audiencia/listaraudiencia`)
    );
}

export function CadastrarAudienciaService(requestBody: IAudiencia) {
    return Service(
        Axios.post<IAudiencia>(
            `/automacao/audiencia/inserirnovaaudiencia`,
            requestBody
        )
    );
}

export function EditarAudienciaService(requestBody: IAudiencia) {
    return Service(
        Axios.put<IAudiencia>(
            `/automacao/audiencia/editaraudiencia`,
            requestBody
        )
    );
}

export function DeletarAudienciaService(idAudiencia: number) {
    return Service(
        Axios.delete<IAudiencia>(
            `/automacao/audiencia/removeraudiencia?idAudiencia=${idAudiencia}`
        )
    );
}

export function ComunicadoEmMassaService(
    tipoComunicação: "Email" | "WhatsApp" | "SMS",
    requestBody: IComunicadoEmMassa
) {
    return Service(
        Axios.post(
            `/automacao/audiencia/comunicadoemmassa?TipoComunicacao=${tipoComunicação}`,
            requestBody
        )
    );
}

export function AgendarComunicadoEmMassaAudienciaService(
    requestBody: IAgendarComunicadoEmMassaAudiencia
) {
    return Service(
        Axios.post(
            `/automacao/audiencia/agendarcomunicadoemmassaaudiencia`,
            requestBody
        )
    );
}

export function AtualizarAgendamentosComunicadosService(
    ID_COMUNICADO_AUDIENCIA: number,
    requestBody: IAgendarComunicadoEmMassaAudiencia
) {
    return Service(
        Axios.put(
            `/automacao/audiencia/atualizaragendamentoscomunicados?ID_COMUNICADO_AUDIENCIA=${ID_COMUNICADO_AUDIENCIA}`,
            requestBody
        )
    );
}

export function DeletarAgendamentoComunicadoService(
    ID_COMUNICADO_AUDIENCIA: number
) {
    return Service(
        Axios.delete(
            `/automacao/audiencia/deletaragendamentocomunicado?ID_COMUNICADO_AUDIENCIA=${ID_COMUNICADO_AUDIENCIA}`
        )
    );
}

export function ListarAgendamentoComunicadoService(
    ID_PAGINA: number,
    QUANTIDADE: number,
    requestBody: IAgendamentosComunicadosRequest
) {
    return Service(
        Axios.post<Array<IAgendamentosComunicadosResponse>>(
            `/automacao/audiencia/listaragendamentocomunicado?ID_PAGINA=${ID_PAGINA}&QUANTIDADE=${QUANTIDADE}`,
            requestBody
        )
    );
}

export function ExecutarAgendamentoComunicadosService(
    ID_COMUNICADO_AUDIENCIA: number
) {
    return Service(
        Axios.post(
            `/automacao/audiencia/executaragendamentodecomunicados?ID_COMUNICADO_AUDIENCIA=${ID_COMUNICADO_AUDIENCIA}`
        )
    );
}

export function GetLogComunicadoService(ID_COMUNICADO_AUDIENCIA: number) {
    return Service(
        Axios.get<Array<ILogComunicado>>(
            `/automacao/audiencia/getlogcomunicado?ID_COMUNICADO_AUDIENCIA=${ID_COMUNICADO_AUDIENCIA}`
        )
    );
}
